import classNames from 'classnames'
import * as React from 'react'

export interface ICoverPhotoOverlayProps {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

export class CoverPhotoOverlay extends React.PureComponent<
  ICoverPhotoOverlayProps
> {
  public render() {
    return (
      <div
        className={classNames('cover-photo-overlay', this.props.className)}
        style={this.props.style}
      >
        {this.props.children}
      </div>
    )
  }
}
